
import React from "react";
import { BaseService, IProfile, ITransaction, PloutousStatus, SanitizedResponse, TransactionAcknowledgementService, TransactionRefundService } from "../../../../../services";
import { ButtonManageRef, ObjectHelper, Scheme } from "@rivtn/noseur";
import { ConfirmDialog, Elements, Siren } from "../../../../shared";
import { i18nManager } from "../../../../../i18n";
import { Utils } from "../../../../../utils";

export interface RefundTransactionProps {
    onComplete: () => void;
    transaction: ITransaction;
}

export function RefundTransaction(props: RefundTransactionProps) {

    let dialogErrorRef: any;
    const { transaction, onComplete } = props;
    const transactionRefundService = TransactionRefundService.getInstance();
    const labels = i18nManager.Labels.dashboard.ploutous.transactions.dialogs.refund_transaction;
    const amount = Utils.makeToMoney(transaction.acknowledged_amount - transaction.refunded_amount);
    const refundPayload = {
        amount,
        type: "FULL",
        business_id: transaction.business_id,
        transaction_reference: transaction.reference,
        description: "Acknowledged by Rivtn Administrator on business behalf",
        refund_reference: "RR" + Utils.randomString(20, "0123456789"),
    };

    const dialog = ConfirmDialog({
        closable: true,
        title: labels.title,
        confirmLabel: labels.confirm_label,
        desc: ObjectHelper.expandStringTemplate(labels.desc, {
            reference: transaction.reference,
            business_service: (`${transaction.extra_data?.business_name ?? ''} (${transaction.extra_data?.service_name ?? ''})`)
        }, { chop: "$" }),
        content: (<div style={{ display: "flex", flexDirection: "column", height: "100%" }}>
            {Elements.buildConfirmDialogForm(labels.form, (name, value) => {
                dialogErrorRef.innerText = " ";
                (refundPayload as any)[name] = parseFloat(value ? value : 0);
                return false;
            }, refundPayload, undefined, { marginTop: 0 })}
            <div ref={(r) => { dialogErrorRef = r; }} className="error" style={{ marginBottom: 0 }}> </div>
        </div>),
        onConfirm: (confirmButton?: ButtonManageRef) => {
            confirmButton?.setLoadingState(true);
            const microAmount = refundPayload.amount * 1000;
            refundPayload.type = (microAmount ? "FULL" : "PARTIAL");
            transactionRefundService.initiateRefund({ ...refundPayload, amount: microAmount }).then(({ apiResponse }: SanitizedResponse<any>) => {
                dialog.destroy(() => {
                    Siren.alert(apiResponse.message);
                    onComplete();
                });
            }).catch((err: any) => {
                BaseService.reportError(err);
                dialogErrorRef.innerText = err?.message ?? err;
            }).finally(() => {
                confirmButton?.setLoadingState(false);
            });
            return false;
        },
    });
    return dialog;
}
